module.exports = __webpack_public_path__ + "img/img.820820eb.jpg";